<template>
  <div>
    <w-modal :active.sync="isActive"
             trap-focus :modal="true"
             aria-role="dialog"
             aria-modal @close="onclose"
             style="overflow: auto">
      <CenterCenter>
        <div class="contentModal">
          <pop-up-title :title="$t('panelPeople.title').toString()"/>
          <b-tabs class="tabsSharing" position="is-left" v-model="tabSelected">
            <b-tab-item>
              <template #header>
                <span>{{ $t('panelPeople.tabShare.title') }}</span>
              </template>
              <div class="contentPanel">
                <perfect-scrollbar class="scrollBarContent" :options="{suppressScrollX:true}">
                  <!-- CHAMPS INPUT -->
                  <div class="inputContent">
                    <div class="labelInput">{{ getPlaceHolder }}</div>
                    <div class="inputLine">
                      <ShareContactInput ref="shareContactInput" @userCommit="userAddToSHare" class="inputContact"
                                         :internal-user="true" :channel="isEditable" :external-user="true" size="middle"
                                         :place-holder="getPlaceHolder" :max-height="300"/>
                      <w-button :loading="loading" icon="send" @click="inviteUser"
                                :enabled="this.listContactToShare.length>0">
                        {{ $t('panelPeople.tabShare.button.add') }}
                      </w-button>
                    </div>
                    <w-error :message="error"/>
                  </div>
                  <div class="channelContainer" v-if="selectedWorkspaceID && weet.channels.length>0">
                    <div class="labelChannel">{{ $t('panelPeople.tabShare.channels.title') }}</div>
                    <transition-group name="list-complete" class="channelLine" v-if="weet.channels.length>0">
                      <ChannelWorkspace v-for="channel in weet.channels"
                                        :key="'channelPeople'+channel.channelID" class="channelItem list-complete-item"
                                        :channel="channel" :selectable="false" :deleteAction="isEditable"
                                        @delete="removeChannel"/>
                    </transition-group>
                    <div v-else class="emptyChannel">
                      {{ $t('panelPeople.tabShare.channels.empty') }}
                    </div>
                  </div>

                  <div class="ownerContainer" v-show="this.weet.owners.length>1">
                    <div class="labelOwners">{{ $t('panelPeople.tabShare.owners.title') }}</div>
                    <div class="listOfUser">
                      <div v-for="owner in weet.owners" :key="'owner'+owner.user.userID">
                        <UserAuthorization :user-share="owner" :weet="weet"
                                           @error="onAuthorizationChangeError"
                                           @deleted="sendUpdate"/>
                      </div>
                    </div>
                  </div>
                </perfect-scrollbar>
              </div>
            </b-tab-item>
            <b-tab-item :disabled="!isEditable">
              <template #header>
                <w-icon :icon="isPrivate?'lock-outline':'link'" size="small"/>
                <span>{{ $t('panelPeople.tabSetting.title') }}</span>
              </template>
              <div class="contentPanel">
                <div class="shareLink" v-if="weet">
                  <ShareVisibilityPolicy :weet="weet"/>
                </div>
                <div class="linkBar">
                  <CopyThumbnailWeetButton :weet="weet" size="small" color="outlined"/>
                  <w-button class="buttonCopy" :expanded="true" icon="link" color="outlined" size="small"
                            @click="copyLink">{{
                      $t('createWeetComponent.settings.copy')
                    }}
                  </w-button>
                </div>
              </div>
            </b-tab-item>
          </b-tabs>

          <!-- CLOSE BUTTON PANEL -->
          <div class="closePanelButton" @click="close">
            <w-icon icon="close" size="small"/>
          </div>
        </div>
      </CenterCenter>
    </w-modal>
  </div>
</template>

<script lang="ts">
import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import store from '@/store';
import WButton from '@/components/wrapper/w-button.vue';
import {Weet, WeetOwer} from '@/store/weet/weetModel';
import {canEditThisWeet, copyLink} from '@/utils/weetUtil';
import WModal from '@/components/wrapper/w-modal.vue';
import PopUpTitle from '@/components/title/PopUpTitle.vue';
import WError from '@/components/wrapper/w-error.vue';
import WInput from '@/components/wrapper/w-input.vue';
import WToolTip from '@/components/wrapper/w-toolTip.vue';
import ShareContactInput from '@/components/share/ShareContactInput.vue';
import WSelect from '@/components/wrapper/w-select.vue';
import ShareCommentPolicy from '@/components/share/ShareCommentPolicy.vue';
import ShareVisibilityPolicy from '@/components/share/ShareVisibilityPolicy.vue';
import UserAuthorization from '@/components/share/UserAuthorization.vue';
import ChannelWorkspace from '@/components/channel/ChannelWorkspace.vue';
import CenterCenter from '@/components/layout/CenterCenter.vue';
import WIcon from '@/components/wrapper/w-icon.vue';
import {REFRESH_WEET_UNBLURED, SET_CHANNELS_TO_WEET} from '@/store/myWeet/myWeetAction';
import {confirmation, inform} from '@/utils/dialog';
import {Channel} from '@/store/channel/channelModel';
import {SHARE_A_WEET, ShareParams} from '@/store/weet/weetAction';
import {setActionEvent} from '@/utils/tracker';
import {ActionEvent} from '@/enum/TrackerEnum';
import {AuthorisationEnum} from '@/enum/AuthorisationEnum';
import {DEFAULT_WEET_TITLE} from '@/store/conf/api';
import {VisibilityPolicy} from '@/store/weet/VisibilityPolicy';
import {isEmail} from '@/utils/util';
import {WORKSPACE_CHANNEL_FILTER} from '@/utils/workspaceUtil';
import uniq from 'lodash/uniq';
import uniqWith from 'lodash/uniqWith';
import {User} from '@/store/user/userModel';
import CopyThumbnailWeetButton from '@/components/actionButton/CopyThumbnailWeetButton.vue';

@Component({
  components: {
    CopyThumbnailWeetButton,
    WIcon,
    CenterCenter,
    ChannelWorkspace,
    ShareVisibilityPolicy,
    ShareCommentPolicy,
    WSelect,
    ShareContactInput, WToolTip, WInput, WError, PopUpTitle, WModal, WButton, UserAuthorization
  }
})
export default class SharePanel extends Vue {
  @Prop()
  private weet!: Weet;
  private mustShow: boolean = false;

  @Prop({default: false})
  private active!: boolean;

  private isActive: boolean = this.active || false;
  private error: string = '';
  private tabSelected: number = 0;
  private loading: boolean = false;

  private listContactToShare: string[] = [];

  private userAddToSHare(values: string[]) {
    this.listContactToShare = values;
  }


  get isPrivate(): boolean {
    return this.weet.visibilityPolicy === VisibilityPolicy.INTERNAL;
  }

  private mounted() {
    this.mustShow = true;
  }

  @Watch('isActive')
  private onActiveChange() {
    if (this.isEditable && this.isActive) {
      // IF an editor open a share panel, then we refresh the Weet with unblured emails
      store.dispatch(REFRESH_WEET_UNBLURED, this.weet.weetID);
    }
  }

  private sendUpdate() {
    this.$emit('updated');
  }

  private onAuthorizationChangeError(error: string) {
    this.error = error;
  }

  private isMe(owner: WeetOwer): boolean {
    const me: User = store.getters.userConnected;
    return me?.userID === owner.user.userID;
  }

  get getPlaceHolder(): string {
    if (!this.selectedWorkspaceID) {
      return this.$t('panelPeople.tabShare.input.placeholder').toString();
    } else {
      if (this.isEditable) {
        return this.$t('panelPeople.tabShare.input.workspacePlaceholder').toString();
      } else {
        return this.$t('panelPeople.tabShare.input.workspacePlaceholderReadonly').toString();
      }
    }

  }


  private removeChannel(channel: Channel) {
    // get list of Channel of weet
    const listOfChannel: string[] = [];
    for (const channelWeet of this.weet.channels) {
      if (channelWeet.channelID !== channel.channelID) {
        listOfChannel.push(channelWeet.channelID);
      }
    }

    store.dispatch(SET_CHANNELS_TO_WEET, {
      weetID: this.weet.weetID,
      channelIDs: listOfChannel
    }).then(() => {
      this.sendUpdate();
      inform(this.$t('panelPeople.tabShare.channels.success').toString());
    });
  }

  @Watch('active')
  private isActiveChange() {
    this.isActive = this.active;
  }

  get isEditable(): boolean {
    if (this.weet === undefined) {
      return false;
    }
    return canEditThisWeet(this.weet);
  }


  get selectedWorkspaceID(): string | null {
    return store.getters.getSelectedWorkspaceID;
  }


  private copyLink() {
    if (this.weet) {
      copyLink(this.weet);
    }
    inform(this.$t('createWeetComponent.share.confirm').toString());
  }

  private async inviteUser() {

    if (this.weet && this.weet.title === DEFAULT_WEET_TITLE && this.isEditable) {
      try {
        await confirmation(this.$t('createWeetComponent.settings.titleValidate.send.validateTitleDescription', {weetTitle: this.weet.title}).toString(),
            this.$t('createWeetComponent.settings.titleValidate.send.validateTitleTitle').toString());
      } catch (e) {
        return;
      }
    }

    this.loading = true;
    let emailsToShare = this.listContactToShare.map((contactOrEmail: any) => {
      return (typeof contactOrEmail === 'string') ? contactOrEmail : contactOrEmail.contactEmail;
    });
    emailsToShare = emailsToShare.filter((value) => {
      return isEmail(value);
    });

    if (emailsToShare.length > 0) {
      let authorisationRight = AuthorisationEnum.COMMENT;
      if (!this.isEditable) {
        authorisationRight = AuthorisationEnum.WATCH;
      }
      const params = new ShareParams(this.weet.weetID, emailsToShare, authorisationRight);
      store.dispatch(SHARE_A_WEET, params).then(() => {
        this.loading = false;
        this.error = '';
        inform(this.$t('shareWeet.confirm').toString());
        setActionEvent(ActionEvent.share_send_contact, {
          number_of_contact: this.listContactToShare.length,
          shared_contacts: this.listContactToShare
        });
        this.listContactToShare = [];
        this.sendUpdate();
      }).catch((err) => {
        this.loading = false;
        this.error = err;
      });
    }

    // filter channel
    let listChannelToAdd: any[] = this.listContactToShare.filter((e) => {
      return e.startsWith(WORKSPACE_CHANNEL_FILTER);
    });

    listChannelToAdd = listChannelToAdd.map((e) => {
      return store.getters.getChannelByName(e.replace(WORKSPACE_CHANNEL_FILTER, ''));
    });
    // now we concanate with the list of channel of the weet
    listChannelToAdd = listChannelToAdd.concat(this.weet.channels);
    // now we transform on list of ids

    listChannelToAdd = listChannelToAdd.map((e) => {
      return e.channelID;
    });
    listChannelToAdd = uniq(listChannelToAdd);
    if (listChannelToAdd.length > 0) {
      store.dispatch(SET_CHANNELS_TO_WEET, {weetID: this.weet.weetID, channelIDs: listChannelToAdd}).then(() => {
        this.loading = false;
        this.sendUpdate();
      });
    }

    (this.$refs.shareContactInput as ShareContactInput).reset();
  }

  private close() {
    this.isActive = false;
    this.onclose();
  }

  private onclose() {
    this.$emit('close');
    this.$emit('update:active', false);
  }


}
</script>

<style scoped lang="scss">

.contentModal {
  background: #FFF;
  max-width: 600px;
  padding: 16px;
  padding-left: 32px;
  padding-right: 32px;
  padding-bottom: 32px;
  border-radius: 8px;
  width: 100%;
  height: 100%;
  margin: auto;
  position: relative;
  min-height: 580px;

  .tabsSharing {
    width: 100%;
    height: 100%;

    .contentPanel {
      padding-top: 16px;

      .scrollBarContent {
        min-height: 400px;
        max-height: 400px;
        width: calc(100% + 64px);
        margin-left: -32px;
        padding-right: 32px;
        padding-left: 32px;
      }
    }

    .inputContent {
      .labelInput {
        font-size: 16px;
        color: var(--dark);
        text-align: left;
        margin-bottom: 8px;
      }

      .inputLine {
        display: flex;

        .inputContact {
          flex: 1;
          margin-right: 8px;
        }
      }
    }

    .channelContainer {

      .labelChannel {
        font-size: 16px;
        color: var(--dark);
        text-align: left;
        margin-top: 16px;
      }

      .channelLine {
        display: flex;
        flex-wrap: wrap;

        .channelItem {
          margin-top: 8px;
        }
      }

      .emptyChannel {
        color: var(--light2);
        font-size: 12px;
        text-align: left;
      }
    }

    .ownerContainer {
      .labelOwners {
        font-size: 16px;
        color: var(--dark);
        text-align: left;
        margin-top: 16px;
      }

      .listOfUser {
        text-align: left;

        .bottomMask {
          position: absolute;
          height: 40px;
          pointer-events: none;
          width: 100%;
          bottom: 0px;
          background: linear-gradient(rgba(255, 255, 255, 0.0), rgba(255, 255, 255, 1));
        }

        .perfectContainer {
          max-height: 230px;
          padding-bottom: 40px;
        }
      }
    }

    .linkBar {
      display: flex;
      width: 100%;
      max-width: 300px;

      .buttonCopy {
        margin-left: 8px;
      }
    }
  }

  .closePanelButton {
    position: absolute;
    width: 24px;
    height: 24px;
    right: 16px;
    top: 16px;
    cursor: pointer;
  }

}
</style>
